import React from 'react';
import { useMeasure } from 'react-use';
import { PluginContextProvider } from '@grafana/data';
import { getAppEvents } from '@grafana/runtime';
import { PanelChrome, ErrorBoundaryAlert, PanelContextProvider } from '@grafana/ui';
import { sceneGraph } from '../../core/sceneGraph.js';

var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function VizPanelRenderer({ model }) {
  var _b;
  const _a = model.useState(), { title, description, options, fieldConfig, pluginLoadError, $data, displayMode, hoverHeader, menu } = _a, state = __objRest(_a, ["title", "description", "options", "fieldConfig", "pluginLoadError", "$data", "displayMode", "hoverHeader", "menu"]);
  const [ref, { width, height }] = useMeasure();
  const plugin = model.getPlugin();
  const parentLayout = sceneGraph.getLayout(model);
  const isDraggable = parentLayout.isDraggable() && ((_b = state.isDraggable) != null ? _b : true);
  const dragClass = isDraggable && parentLayout.getDragClass ? parentLayout.getDragClass() : "";
  const dragClassCancel = isDraggable && parentLayout.getDragClassCancel ? parentLayout.getDragClassCancel() : "";
  const rawData = sceneGraph.getData(model).useState();
  const dataWithFieldConfig = model.applyFieldConfig(rawData.data);
  const titleInterpolated = model.interpolate(title, void 0, "text");
  const timeZone = sceneGraph.getTimeRange(model).state.timeZone;
  if (pluginLoadError) {
    return /* @__PURE__ */ React.createElement("div", null, "Failed to load plugin: ", pluginLoadError);
  }
  if (!plugin) {
    return /* @__PURE__ */ React.createElement("div", null, "Loading plugin panel...");
  }
  if (!plugin.panel) {
    return /* @__PURE__ */ React.createElement("div", null, "Panel plugin has no panel component");
  }
  const PanelComponent = plugin.panel;
  if ($data && $data.setContainerWidth) {
    $data.setContainerWidth(width);
  }
  const titleItems = [];
  if (model.state.$timeRange) {
    titleItems.push(/* @__PURE__ */ React.createElement(model.state.$timeRange.Component, {
      model: model.state.$timeRange
    }));
  }
  let panelMenu;
  if (menu) {
    panelMenu = /* @__PURE__ */ React.createElement(menu.Component, {
      model: menu
    });
  }
  const data = dataWithFieldConfig;
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    style: { position: "absolute", width: "100%", height: "100%" }
  }, width > 0 && height > 0 && /* @__PURE__ */ React.createElement(PanelChrome, {
    title: titleInterpolated,
    description: description ? () => model.interpolate(description) : "",
    loadingState: data.state,
    statusMessage: getChromeStatusMessage(data, pluginLoadError),
    width,
    height,
    displayMode,
    hoverHeader,
    titleItems,
    dragClass,
    dragClassCancel,
    padding: plugin.noPadding ? "none" : "md",
    menu: panelMenu
  }, (innerWidth, innerHeight) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorBoundaryAlert, {
    dependencies: [plugin, data]
  }, /* @__PURE__ */ React.createElement(PluginContextProvider, {
    meta: plugin.meta
  }, /* @__PURE__ */ React.createElement(PanelContextProvider, {
    value: model.getPanelContext()
  }, /* @__PURE__ */ React.createElement(PanelComponent, {
    id: 1,
    data,
    title,
    timeRange: data.timeRange,
    timeZone,
    options,
    fieldConfig,
    transparent: false,
    width: innerWidth,
    height: innerHeight,
    renderCounter: 0,
    replaceVariables: model.interpolate,
    onOptionsChange: model.onOptionsChange,
    onFieldConfigChange: model.onFieldConfigChange,
    onChangeTimeRange: model.onChangeTimeRange,
    eventBus: getAppEvents()
  })))))));
}
function getChromeStatusMessage(data, pluginLoadingError) {
  if (pluginLoadingError) {
    return pluginLoadingError;
  }
  return data.error ? data.error.message : void 0;
}

export { VizPanelRenderer };
//# sourceMappingURL=VizPanelRenderer.js.map
